module.exports = __webpack_public_path__ + "assets/img/1612_01.jpg?c7296f84de036488685a4539b6dcdce2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1612_01.jpg
// module id = 1118
// module chunks = 0